<div *ngIf="vm$ | async as vm">
  <div [class]="vm.states.get(emailStateId)?.key">
    {{ vm.states.get(emailStateId)?.name }}
  </div>
</div>
